import IdealStudio from "./main";

// Expose IdealStudio globally
if (typeof window !== "undefined") {
  window.IdealStudio = IdealStudio;
}

export default IdealStudio;
